import { cn } from '@/lib/utils';
import { type BrandConfig } from '@/config/branding';
import { useEffectiveBranding } from '@/hooks/use-effective-branding';

type BrandLogoProps = {
  brand?: BrandConfig;
  className?: string;
};

export const BrandLogo = ({ brand: brandOverride, className = 'h-12 w-auto' }: BrandLogoProps) => {
  const effective = useEffectiveBranding();
  const brand = brandOverride ?? effective;

  // Incomplete/neutral partner brand: render nothing rather than a broken <img>.
  if (!brand.logo) return null;

  return (
    <>
      <img src={brand.logo} alt={brand.appName} className={cn(className, brand.logoDark && 'dark:hidden')} />
      {brand.logoDark ? (
        <img src={brand.logoDark} alt={brand.appName} className={cn('hidden dark:block', className)} />
      ) : null}
    </>
  );
};
